export default __webpack_public_path__ + "static/media/Icon-Board-Add.5ac57f40.svg";